import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApiService } from 'src/lib/services/api.service';
import linkifyStr from "linkify-string";
import "linkify-plugin-ticket";

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {

	defaultOptions = {}

	constructor(private window: Window,
				private apiService: ApiService,
				private domSanitizer: DomSanitizer) { }

    transform(value: string, options: any = {}): SafeHtml {

		if(!value)
			return value;

		const isHTML = /<\/?[a-z][\s\S]*>/i.test(value);

		if(isHTML) {

			const document = new DOMParser().parseFromString(value, 'text/html');
			const isApiUrl: RegExp = new RegExp(`(${this.window.location.origin}\\/api[\\w\\-\\._~:\\/?#[\\]@!\\$&\\'\\(\\)\\*\\+,;=.]+)`, 'i');
			const isLetsignitUrl: RegExp = new RegExp(`[a-z]+\.letsignit\.com`, 'i');

			Array.from(document.body.querySelectorAll('img')).each(image => {

				const imageUrlBuilder = new URL(image.src, this.window.location.origin);

				if(image.src.match(isApiUrl) && !imageUrlBuilder.searchParams.has('token')) {
					imageUrlBuilder.searchParams.append('token', this.apiService.token);
					image.src = imageUrlBuilder.toString();
					image.alt = imageUrlBuilder.pathname.split('/').last;
				}

				else if(image.src.match(isLetsignitUrl))
					image.remove();
			});

			Array.from(document.body.querySelectorAll('a')).each(link => {

				if(link.href.match(isLetsignitUrl))
					link.remove();
			});

			value = document.body.innerHTML;
		
		} else
			value = linkifyStr(value, {...this.defaultOptions, ...options});

		// Empty tags & <br> cleaner
		value = value.replace(/<([a-z]+)[^>]*>([\s\u00A0]|&nbsp;)*<\/\1>|<br\s*\/?>/gi, '');

		return this.domSanitizer.bypassSecurityTrustHtml(value);
	}
}